import { useMentionConfidenceActions } from '@app/modules/audit/modules/station-audit/components/mentions/useMentionConfidenceActions';
import { AuditLiveMentionConfidence } from '@mi-front/core';
import { Spinner } from '@mi-front/ui';
import {
  ThumbDownOutlined as ThumbDownOutlinedIcon,
  ThumbUp as ThumbUpIcon,
  ThumbUpOutlined as ThumbUpOutlinedIcon,
} from '@mui/icons-material';
import { Box, IconButton, Tooltip } from '@mui/material';
import { defineMessage, FormattedMessage } from 'react-intl';

const ACCEPT_MENTION_MESSAGE = defineMessage({
  id: 'audit.liveMentions.acceptMention',
  defaultMessage: 'Aceptar mention',
});

const REJECT_MENTION_MESSAGE = defineMessage({
  id: 'audit.liveMentions.rejectMention',
  defaultMessage: 'Rechazar mention',
});

type MentionConfidenceButtonsProps = {
  confidence: AuditLiveMentionConfidence;
  isLoading: boolean;
  onConfidenceChange: (confidence: AuditLiveMentionConfidence) => void;
  className?: string;
};

/**
 * Displays the accept and reject actions for a live mention confidence.
 */
export function MentionConfidenceButtons({
  confidence,
  isLoading,
  onConfidenceChange,
  className,
}: MentionConfidenceButtonsProps) {
  const { onAccept, onReject, canChange } = useMentionConfidenceActions({
    confidence,
    onConfidenceChange,
  });

  if (isLoading) {
    return (
      <Box className={className}>
        <Spinner />
      </Box>
    );
  }

  if (!canChange) {
    return null;
  }

  return (
    <Box className={className} sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      <Tooltip title={<FormattedMessage {...ACCEPT_MENTION_MESSAGE} />}>
        <IconButton size="small" color="success" onClick={onAccept}>
          {confidence === AuditLiveMentionConfidence.ACCEPTED ? (
            <ThumbUpIcon fontSize="small" />
          ) : (
            <ThumbUpOutlinedIcon fontSize="small" />
          )}
        </IconButton>
      </Tooltip>
      <Tooltip title={<FormattedMessage {...REJECT_MENTION_MESSAGE} />}>
        <IconButton size="small" color="error" onClick={onReject}>
          <ThumbDownOutlinedIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
  );
}
